import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function commentReducer(state = initialState.comments, action) {
  let content = { ...state };

  switch (action.type) {
    case types.LOAD_COMMENTS_SUCCESS: {
      content = action.comments;
      return content;
    }

    case types.LOAD_MORE_COMMENTS_SUCCESS: {
      const previousComments = content.data;
      content = action.comments;
      content.data = [...previousComments, ...content.data];
      return content;
    }

    case types.ADD_COMMENT_SUCCESS: {
      let newCount = content.count;
      newCount += 1;

      content.data = [action.comment, ...state.data];
      content.count = newCount;
      return content;
    }

    case types.DELETE_COMMENT_SUCCESS: {
      let newCount = content.count;
      newCount -= 1;

      content.data = content.data.filter(comment => comment.id !== action.commentId);
      content.count = newCount;
      return content;
    }

    case types.ADD_COMMENT_LIKE_SUCCESS: {
      content.data = content.data.map((comment) => {
        const newObj = { ...comment };
        if (newObj.id === action.commentId) {
          newObj.liked = true;
          newObj.likes = newObj.likes.concat(action.loggedInUserId);
        }
        return newObj;
      });
      return content;
    }

    case types.REMOVE_COMMENT_LIKE_SUCCESS: {
      content.data = content.data.map((comment) => {
        const newObj = { ...comment };
        if (newObj.id === action.commentId) {
          newObj.liked = false;
          newObj.likes = newObj.likes.filter(like => like !== action.loggedInUserId);
        }
        return newObj;
      });
      return content;
    }

    case types.REPLY_TO_COMMENT_SUCCESS: {
      const commentToChangeIndex = content.data.findIndex(({ id }) => id === action.parentCommentId);
      const comment = content.data[commentToChangeIndex];
      const updatedComment = {
        ...comment,
        replies: [...comment.replies, action.reply],
      };

      return {
        ...state,
        data: [
          ...content.data.slice(0, commentToChangeIndex), // The replies before the new comment
          updatedComment, // the updated comment
          ...content.data.slice(commentToChangeIndex + 1), // the comments after the updated comment
        ],
      };
    }

    case types.DELETE_REPLY_SUCCESS: {
      const commentToChangeIndex = content.data.findIndex(({ id }) => id === action.parentCommentId);
      const comment = content.data[commentToChangeIndex];
      const updatedComment = {
        ...comment,
        replies: comment.replies.filter(reply => reply.id !== action.replyId),
      };
      return {
        ...state,
        data: [
          ...content.data.slice(0, commentToChangeIndex), // the comments before the updated comment
          updatedComment, // the updated comment
          ...content.data.slice(commentToChangeIndex + 1), // the comments after the updated comment
        ],
      };
    }

    case types.ADD_REPLY_LIKE_SUCCESS: {
      const commentToChangeIndex = content.data.findIndex(({ id }) => id === action.parentCommentId);
      const comment = content.data[commentToChangeIndex];
      const updatedReplies = comment.replies.map((reply) => {
        const newObj = { ...reply };
        if (newObj.id === action.replyId) {
          newObj.liked = true;
          newObj.likes = newObj.likes.concat(action.loggedInUserId);
        }
        return newObj;
      });

      const updatedComment = {
        ...comment,
        replies: updatedReplies,
      };

      return {
        ...state,
        data: [
          ...content.data.slice(0, commentToChangeIndex), // the comments before the updated comment
          updatedComment, // the updated comment
          ...content.data.slice(commentToChangeIndex + 1), // the comments after the updated comment
        ],
      };
    }

    case types.REMOVE_REPLY_LIKE_SUCCESS: {
      const commentToChangeIndex = content.data.findIndex(({ id }) => id === action.parentCommentId);
      const comment = content.data[commentToChangeIndex];
      const updatedReplies = comment.replies.map((reply) => {
        const newObj = { ...reply };
        if (newObj.id === action.replyId) {
          newObj.liked = false;
          newObj.likes = newObj.likes.filter(like => like !== action.loggedInUserId);
        }
        return newObj;
      });

      const updatedComment = {
        ...comment,
        replies: updatedReplies,
      };

      return {
        ...state,
        data: [
          ...content.data.slice(0, commentToChangeIndex), // the comments before the updated comment
          updatedComment, // the updated comment
          ...content.data.slice(commentToChangeIndex + 1), // the comments after the updated comment
        ],
      };
    }

    case types.REPORT_COMMENT_SUCCESS: {
      content.data = content.data.map((comment) => {
        const newObj = { ...comment };
        if (newObj.id === action.commentId) {
          newObj.reported = true;
        }
        return newObj;
      });
      return content;
    }

    case types.REPORT_REPLY_SUCCESS: {
      const commentToChangeIndex = content.data.findIndex(({ id }) => id === action.parentCommentId);
      const comment = content.data[commentToChangeIndex];
      const updatedReplies = comment.replies.map((reply) => {
        const newObj = { ...reply };
        if (newObj.id === action.replyId) {
          newObj.reported = true;
        }
        return newObj;
      });

      const updatedComment = {
        ...comment,
        replies: updatedReplies,
      };

      return {
        ...state,
        data: [
          ...content.data.slice(0, commentToChangeIndex), // the comments before the updated comment
          updatedComment, // the updated comment
          ...content.data.slice(commentToChangeIndex + 1), // the comments after the updated comment
        ],
      };
    }

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./library/app/reducers/commentReducer.js